<template>
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header py-0">
      <h6 class="py-3 mb-0">Usuários Associados ao Cargo</h6>
    </div>
    <div v-if="users.length > 0" class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Nome de Usuário</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th class="text-center">Status</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.name }}</td>
            <td>{{ user.nickname ? user.nickname : '-' }}</td>
            <td>{{ user.email ? user.email : '-' }}</td>
            <td>{{ user.phone ? user.phone : '-' }}</td>
            <td class="text-center" v-html="statusTranslate(user.status)" />
            <td class="text-center">
              <router-link
                :to="`/users/${user.id}`"
                class="btn btn-outline-primary btn-icon rounded-pill"
                title="Visualizar Detalhes do Usuário"
              >
                <i class="ph-file-text" />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p>Este cargo não está associado a nenhum usuário</p>
      <router-link
        :to="`/users`"
        class="btn btn-outline-dark"
        title="Listagem de Usuários"
      >
        Listagem de Usuários
      </router-link>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'UsersRole',

  components: {
    LoadingData,
  },

  props: {
    roleId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      users: {},
      statusTranslate,
    }
  },

  methods: {
    async getUsersRole() {
      try {
        this.users = await this.$store.dispatch('getUsersRole', this.roleId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getUsersRole()
  },
}
</script>
